type PercentBarOpaqueProps = {
  percent: number;
  testId?: string;
  fillColor?: string;
};

const PercentBarOpaque = ({
  percent,
  testId = "PercentBarOpaqueContainer",
  fillColor = "#22c55e",
}: PercentBarOpaqueProps) => {
  const clampedPercent = Math.min(Math.max(percent, 0), 100);
  const displayPercent = Math.round(percent);

  return (
    <div
      data-testid={testId}
      id={testId}
      className="relative flex h-4 w-full items-center overflow-hidden rounded text-black outline-1 outline-[#3D3F44] outline "
      style={{ backgroundColor: "transparent", opacity: 0.6 }}
    >
      <div
        className="absolute left-0 top-0 h-full text-black rounded transition-all duration-300"
        style={{
          width: `${clampedPercent}%`,
          backgroundColor: fillColor,
          opacity: 0.7,
        }}
      />
      <span className="relative z-10 w-full text-center text-xs font-semibold text-black dark:text-white">
        {displayPercent}%
      </span>
    </div>
  );
};

export default PercentBarOpaque;
